import { Layout } from 'antd';
import { PropsWithChildren, ReactNode, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import styles from './Layout.module.less';
import { LayoutProvider } from './LayoutContext';
import SideBar from './SideBar';

export default function LayoutComponent({ children }: PropsWithChildren<ReactNode>) {
	const { pathname } = useLocation();

	useLayoutEffect(() => {
		document.documentElement.scrollTo(0, 0);
	}, [pathname]);

	return (
		<LayoutProvider>
			<Layout className={styles.layout}>
				<Header />
				<Layout.Content>
					<div className={styles.layoutContent}>
						<SideBar />
						<main>{children}</main>
					</div>
				</Layout.Content>
				<Footer />
			</Layout>
		</LayoutProvider>
	);
}